import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2, Lock } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PlatformTile } from "@/components/PlatformTile";

export default function Connections() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/connections").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const connect = async (id) => { try { await api.post(`/connections/${id}/connect`); } catch (e) { toast.error(errorMessage(e)); } };
  return (
    <div className="space-y-6 rise" data-testid="connections-page">
      <div><span className="overline-label">Connections</span><h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Publishing channels</h1>
        <p className="text-muted-foreground text-sm mt-2 max-w-2xl">Accounts are kept separate from the mobile app. Each platform needs its own developer OAuth credentials before a real connection can be made — nothing here is simulated.</p></div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((c) => (
          <div key={c.id} className="card-surface card-hover p-5 space-y-4" data-testid={`connection-${c.id}`}>
            <div className="flex items-center justify-between">
              <p className="font-semibold flex items-center gap-2.5"><PlatformTile id={c.id} /> {c.label}</p>
              <span className={`chip text-xs ${c.connected ? "chip-active" : "chip-idle"}`} data-testid={`connection-status-${c.id}`}>{c.connected ? "Connected" : c.configured ? "Not connected" : "Needs credentials"}</span>
            </div>
            <p className="text-xs font-mono text-muted-foreground">{c.framing} · max {c.max_seconds}s</p>
            <Button onClick={() => connect(c.id)} variant="outline" className="btn-pill w-full" data-testid={`connection-connect-${c.id}`}>
              {c.configured ? <><Link2 size={14} className="mr-2" /> Connect</> : <><Lock size={14} className="mr-2" /> Connect (credentials required)</>}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
